import labelIds from './label_ids.json';

export type LabelKey = keyof typeof labelIds;

// Typed constant for label keys — use instead of hardcoding string literals.
// Provides autocomplete and compile-time safety.
export const LABEL_KEYS: { readonly [K in LabelKey]: K } = Object.fromEntries(
  Object.keys(labelIds).map((k) => [k, k])
  // eslint-disable-next-line no-use-before-define
) as { readonly [K in LabelKey]: K };
